<template>
  <div>
    <div :style="contentColor" class="titleContent">
      <img
        :src="pagerPrefixUrl"
        alt
        style="width: 100%;"
        :style="pagerPrefixStyle"
        v-if="pagerPrefixUrl"
      />
      <span>{{ title }}</span>
      <span v-if="hasPager">({{ dataChart.total }})</span>
    </div>
    <template v-if="hasData">
      <ul class="yScroll" :style="yHeight">
        <li v-for="item in dataChart" :key="item.id" @click="goLink(item)">
          <div class="contentLeft" :style="getbgColor(item.type)" v-if="hasTag">
            {{ item.type | textstyle }}
          </div>
          <div class="contentRight">
            <a :href="item.url" :style="titleStyle" target="_blank" :title="item.title"
              >{{ item.title }}
            </a>
            <p class="authorsize" :style="sourceSize">
              来源 : {{ item.author }} | 发布时间 : {{ item.publish_date }}
            </p>
          </div>
        </li>
      </ul>
    </template>
    <template v-else>
      <avue-echart-empty />
    </template>
  </div>
</template>
<script>
import init from '@/mixins/chart';
export default {
  name: 'textscroll',
  mixins: [init],
  props: {
    option: Object,
    component: Object
  },
  filters: {
    textstyle(value) {
      return value.slice(0, 1);
    }
  },
  computed: {
    title() {
      return this.option.title;
    },
    contentColor() {
      return {
        fontSize: (this.option.textSize || 30) + 'px',
        color: this.option.textColor
      };
    },
    pagerPrefixUrl() {
      return this.option.pagerPrefixUrl;
    },
    pagerPrefixStyle() {
      return {
        width: this.setPx(this.option.pagerPrefixSize),
        height: this.setPx(this.option.pagerPrefixSize),
        marginRight: this.setPx(this.option.pagerPrefixSplit)
      };
    },
    hasPager() {
      return this.dataChart.total;
    },
    yHeight() {
      return {
        height: this.component.height + 'px'
      };
    },
    titleStyle() {
      return {
        width: this.component.width + 'px',
        height: (this.option.typeWidth || 16) + 'px',
        fontSize: (this.option.titleText || 30) + 'px',
        color: this.option.titleColor || '#fff',
        lineHeight: this.setPx(this.option.tagLineHeight || 16)
      };
    },
    sourceSize() {
      return {
        fontSize: (this.option.sourceText || 30) + 'px',
        color: this.option.sourceColor || '#fff'
      };
    },
    hasTag() {
      return this.option.hasTag;
    },
    hasData() {
      return this.dataChart?.length > 0;
    }
  },
  methods: {
    getbgColor(type) {
      let val = type || '';
      if (this.option.customColor) {
        try {
          const data = JSON.parse(this.option.customColor);
          val = data[val] || val;
        } catch {
          //
        }
      }
      return {
        fontSize: (this.option.typeSize || 30) + 'px',
        width: (this.option.typeWidth || 16) + 'px',
        height: (this.option.typeWidth || 16) + 'px',
        color: this.option.titleColor,
        lineHeight: this.setPx(this.option.tagLineHeight || 16),
        textAlign: this.option.textAlign,
        backgroundColor: val
      };
    },
    goLink(obj) {
      this.progressClick(obj);
    }
  }
};
</script>

<style lang="scss" scoped>
.titleContent {
  margin-bottom: 10px;
}
ul li {
  list-style: none;
  display: flex;
}
// 文字滚动
.yScroll {
  overflow-y: scroll;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
.contentLeft {
  margin-bottom: 5px;
  margin-right: 20px;
}
.contentRight {
  margin-bottom: 5px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.authorsize {
  padding: 5px 0;
}
</style>
